import React from "react";
import { FaStore, FaTruck, FaUsers, FaShoppingCart } from "react-icons/fa";

const ServicesSection = () => {
  return (
    <>
      <section className="servicesSection">
        <p className="servicesLabel">OUR SERVICES</p>

        <h2>Everything you need for a successful event</h2>

        <p className="servicesIntro">
          From concept to completion, we provide end-to-end merchandise and
          retail solutions tailored to your event.
        </p>

        <div className="servicesGrid">
          <div className="serviceCard">
            <FaStore className="serviceIcon" />
            <h3>Merchandise concession infrastructure</h3>
            <p>
              Custom built infrastructure to deliver a seamless merchandise
              experience.
            </p>
            <a href="#">LEARN MORE →</a>
          </div>

          <div className="serviceCard">
            <FaTruck className="serviceIcon" />
            <h3>Mobile Retail Trailer Unit</h3>
            <p>
              Fully equipped mobile retail solutions that go wherever your event
              is.
            </p>
            <a href="#">LEARN MORE →</a>
          </div>

          <div className="serviceCard">
            <FaUsers className="serviceIcon" />
            <h3>Staff and supervision</h3>
            <p>
              Experienced, professional staff to keep operations running
              smoothly.
            </p>
            <a href="#">LEARN MORE →</a>
          </div>

          <div className="serviceCard">
            <FaShoppingCart className="serviceIcon" />
            <h3>E-commerce online store</h3>
            <p>
              Online stores that extend your event reach and grow your brand.
            </p>
            <a href="#">LEARN MORE →</a>
          </div>
        </div>

        <div className="coverageLine">
          <span></span>
          <p>✓ Nationwide coverage across New Zealand</p>
          <span></span>
        </div>
      </section>

      <style>{`
        .servicesSection {
          width: 100%;
          padding: 20px 20px;
          background: #ffffff;
          text-align: center;
          font-family: Arial, sans-serif;
        }

        .servicesLabel {
          color: #008cff;
          font-size: 15px;
          font-weight: 800;
          letter-spacing: 2px;
          margin-bottom: 12px;
        }

        .servicesSection h2 {
          color: #07194a;
          font-size: 30px;
          line-height: 1.1;
          font-weight: 900;
          margin: 0;
        }

        .servicesIntro {
          max-width: 680px;
          margin: 24px auto 60px;
          color: #56627a;
          font-size: 20px;
          line-height: 1.5;
        }

        .servicesGrid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 28px;
        }

        .serviceCard {
          min-height: 360px;
          padding: 48px 34px 38px;
          border: 1px solid #dfe5ef;
          border-radius: 12px;
          background: #ffffff;
          box-shadow: 0 10px 24px rgba(7, 25, 74, 0.05);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          transition: all 0.3s ease;
        }

        .serviceCard:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 36px rgba(7, 25, 74, 0.12);
          border-color: #008cff;
        }

        .serviceIcon {
          font-size: 72px;
          color: #007cff;
          margin-bottom: 28px;
        }

        .serviceCard h3 {
          color: #07194a;
          font-size: 24px;
          line-height: 1.15;
          font-weight: 900;
          margin: 0 0 22px;
        }

        .serviceCard p {
          color: #56627a;
          font-size: 17px;
          line-height: 1.45;
          margin: 0 0 30px;
        }

        .serviceCard a {
          color: #008cff;
          text-decoration: none;
          font-size: 15px;
          font-weight: 900;
          letter-spacing: 1px;
        }

        .coverageLine {
          max-width: 1300px;
          margin: 60px auto 0;
          display: flex;
          align-items: center;
          gap: 24px;
          color: #56627a;
          font-size: 20px;
        }

        .coverageLine span {
          flex: 1;
          height: 1px;
          background: #dfe5ef;
        }

        .coverageLine p {
          margin: 0;
          white-space: nowrap;
        }

        @media (max-width: 1100px) {
          .servicesGrid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .servicesSection {
            padding: 60px 16px;
          }

          .servicesSection h2 {
            font-size: 35px;
          }

          .servicesIntro {
            font-size: 17px;
            margin-bottom: 40px;
          }

          .servicesGrid {
            grid-template-columns: 1fr;
          }

          .coverageLine {
            font-size: 16px;
            gap: 12px;
          }

          .coverageLine p {
            white-space: normal;
          }
        }
      `}</style>
    </>
  );
};

export default ServicesSection;